<template>
    <div class="monitoring">
        <div class="container">
            <div class="monitoring__header">
                <h2>Мониторинг сотрудников и членов их семей</h2>
                <!-- <select v-model="groupSelect" v-if="userGroups && userGroups.length > 1">
                    <option value="" selected disabled hidden>Выбор группы</option>
                    <option v-for="(e,i) in userGroups" :key="i" :value="e">{{e.owner_short_name ? e.owner_short_name : e.id}}</option>
                </select> -->
            </div>
            <div class="monitoring__content">
                <div class="monitoring__content-search-block">
                    <input v-model="searchQuery" class="monitoring__content-search" value="" @keypress.enter="() => { getCompanies() }" placeholder="Поиск по ИНН ФЛ или ФИО"/>
                    <i @click="() => { searchQuery = ''; getCompanies() }" v-if="searchQuery" class="lnr lnr-cross"></i>
                    <i @click="() => { getCompanies() }" v-if="searchQuery" class="lnr lnr-magnifier"></i>
                </div>
                <shestirenkaLoader  v-if="loading" />
                <template v-else-if="monitoringCompanies.length">
                    <div class="monitoring__content-sort">
                        <span>Сортировать: </span>
                        <span class="monitoring__content-sort-item" @click="sortBy('changed_at')">
                            <template v-if="order_by == 'changed_at'">
                                <i class="fas fa-chevron-up" v-if="order_type == 'desc'"></i>
                                <i class="fas fa-chevron-down" v-if="order_type == 'asc'"></i>
                            </template>
                            <span>по дате изменения</span>
                        </span>
                        <span class="monitoring__content-sort-item" @click="sortBy('rstperson_fio')">
                            <template v-if="order_by == 'rstperson_fio'">
                                <i class="fas fa-chevron-up" v-if="order_type == 'desc'"></i>
                                <i class="fas fa-chevron-down" v-if="order_type == 'asc'"></i>
                            </template>
                            <span>по ФИО</span>
                        </span>
                        <span class="monitoring__content-sort-item" @click="sortBy('count_unseen')">
                            <template v-if="order_by == 'count_unseen'">
                                <i class="fas fa-chevron-up" v-if="order_type == 'desc'"></i>
                                <i class="fas fa-chevron-down" v-if="order_type == 'asc'"></i>
                            </template>
                            <span>по кол-ву новых изменений</span>
                        </span>
                    </div>
                    <pagination v-if="pagination" :pagination="pagination" :onTurnPageCallBack="getCompanies" :showRowsPerPageSelection="true" :rows_on_page="monitoringCompanies.length" />
                    <table class="monitoring__table">
                        <thead>
                            <tr class="monitoring__table-header">
                                <th>ИНН ФЛ</th>
                                <th>
                                    <span>ФИО, должность, родство</span>
                                </th>
                                <!-- <th>Дата постановки <br> на мониторинг</th> -->
                                <th>
                                    <div>Последнее изменение</div>
                                </th>
                                <th class="monitoring__table-header-changes">
                                    <div>Кол-во изменений</div>
                                    <div style="font-size: 12px">({{countUnseen}} из {{countTotal}})</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="monitoring__table-item" v-for="(e,i) in monitoringCompanies" :key="i">
                                <td>{{e.rstperson_inn}}</td>
                                <td>
                                    <person-afil v-if="e.rstperson_inn" :inn="e.rstperson_inn" :fio="e.rstperson_fio" :showAfilNetworkTooltip="true" />
                                    <div v-else>{{e.rstperson_fio}}</div>
                                    <div v-if="e.rstperson_type == 'relative'">
                                        <span>{{e.rstperson_role ? `${e.rstperson_role} сотрудника` : 'сотрудник'}}</span>
                                        <person-afil v-if="e.relation_inn" :inn="e.relation_inn" :fio="e.relation_name" :showAfilNetworkTooltip="true" />
                                        <span v-else>{{e.relation_name}}</span>
                                    </div>
                                    <div v-else-if="e.rstperson_type == 'staff'">
                                        <span>{{e.rstperson_role ? e.rstperson_role : 'сотрудник'}}</span>
                                        <a v-if="e.relation_ogrn" :href="`/company/${e.relation_ogrn}`" target="_blank" class="blue-red-hover-text">{{e.relation_name}}</a>
                                        <span v-else>{{e.relation_name}}</span>
                                    </div>
                                    <div v-else><span>сотрудник</span></div>
                                </td>
                                <!-- <td>
                                    <span v-if="e.started_at">{{new Date(e.started_at).toLocaleDateString()}}</span>
                                </td> -->
                                <td>
                                    <div>{{new Date(e.changed_at).toLocaleDateString()}}</div>
                                    <div>{{changeTypeTitle(e.change_type_title)}}</div>
                                </td>
                                <td class="monitoring__table-item-changes">
                                    <div class="monitoring__table-item-changes-new">Новых {{e.count_unseen}}</div>
                                    <div class="monitoring__table-item-changes-all">Всего {{e.count_total}}</div>
                                    <div @click="showCompanyChanges(0, 50, e.rstperson_inn, e.rstperson_fio)" class="monitoring__table-item-changes-show">Показать</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination v-if="pagination" :pagination="pagination" :onTurnPageCallBack="getCompanies" :showRowsPerPageSelection="true" :rows_on_page="monitoringCompanies.length" />
                </template>
                <template v-else>
                    <h3 style="margin: 10px 0">Сотрудник не найден</h3>
                </template>
            </div>
        </div>
        <modal 
            v-if="showCompanyChangesModal" 
            :close="closeModalHandler" 
            :printButton="true" 
            :downloadButton="false"
        >
            <span slot="modalHeader">Список изменений <a :href="`/company/${comapnyChangesOGRN}`" target="_blank" style="border: 0">{{comapnyChangesName}}</a></span>
            <div slot="modalBody" style="padding: 10px">
                <pagination v-if="companyChangesPagination" :pagination="companyChangesPagination" :onTurnPageCallBack="getCompanyChanges" :showRowsPerPageSelection="true" :rows_on_page="companyChangesData.length" />
                <table class="simple-table">
                    <thead>
                        <tr>
                            <th>Изменение</th>
                            <th>Дата обновления информации</th>
                            <th>Старые данные</th>
                            <th>Новые данные</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(e,i) in companyChangesData" :key="i">
                            <td style="font-weight: 400">
                                <span v-if="e.change_type_title">{{e.change_type_title}}</span>
                                <span v-else-if="e.change_type == 'added'">
                                    Регистрация ИП
                                </span>
                                <span v-else-if="e.change_type == 'updated'">
                                    <span>Изменение информации о собственности</span>
                                    <card-link :ogrn="e.ogrn">{{e.name_short ? e.name_short : e.name_full}}</card-link>
                                </span>
                                <span v-else-if="e.change_type == 'deleted'">
                                    Ликвидация ИП
                                </span>
                                <span v-else>—</span>
                            </td>
                            <td>{{new Date(e.changed_at).toLocaleDateString()}}</td>
                            <td>
                                <template v-if="e.data_old && e.data_old.length && e.data_old[0] != null">
                                    <div v-for="(e,i) in e.data_old" :key="i">
                                        <p v-if="e.title" style="font-weight: 400; margin: 15px 0">{{e.title}}</p>
                                        <p v-if="e.value">{{e.value}}</p>
                                        <card-link v-if="e.ogrn && e.name_full" :ogrn="e.ogrn">{{e.name_full}}</card-link>
                                        <template v-if="e.attributes && e.attributes.length">
                                            <p v-for="(e,i) in e.attributes" :key="i" style="margin: 0">
                                                <span v-if="e.title">{{e.title}}:</span>
                                                <span v-if="e.value">{{e.value}}</span>
                                            </p>
                                        </template>
                                    </div>
                                </template>

                                <template v-else>—</template>
                            </td>
                            <td>
                                <template v-if="e.data_new && e.data_new.length && e.data_new[0] != null">
                                    <template v-if="e.change_type == '/КадНовый' && e.data_new[0].id">
                                        <a :href="`http://kad.arbitr.ru/Card/${e.data_new[0].id}`" target="_blank">{{e.data_new[0].number}}</a>
                                    </template>
                                    <template v-else>
                                        <div v-for="(e,i) in e.data_new" :key="i">
                                            <p v-if="e.title" style="font-weight: 400; margin: 15px 0">{{e.title}}</p>
                                            <p v-if="e.value">{{e.value}}</p>
                                            <card-link v-if="e.ogrn && e.name_full" :ogrn="e.ogrn">{{e.name_full}}</card-link>
                                            <template v-if="e.attributes && e.attributes.length">
                                                <p v-for="(e,i) in e.attributes" :key="i" style="margin: 0">
                                                    <span v-if="e.title">{{e.title}}:</span>
                                                    <span v-if="e.value">{{e.value}}</span>
                                                </p>
                                            </template>
                                        </div>
                                    </template>
                                </template>

                                <template v-else>—</template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination v-if="companyChangesPagination" :pagination="companyChangesPagination" :onTurnPageCallBack="getCompanyChanges" :showRowsPerPageSelection="true" :rows_on_page="companyChangesData.length" />
            </div>
            <!-- <button slot="modalFooter" @click="downloadXLSX(comapnyChangesOGRN)" class="uk-button"><i class="lnr lnr-download"></i> Сохранить в .xlsx</button> -->
        </modal>
    </div>
</template>

<script>
import axios from 'axios'
import modal from '@/components/ui/modal.vue'
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'
import pagination from '@/components/ui/pagination.vue'
import cardLink from '@/components/ui/cardLink.vue'

export default {
    components: {
        modal,
        cardLink,
        shestirenkaLoader,
        pagination
    },
    data() {
        return {
            groupSelect: '',
            ogrnUploadList: '',
            showAddMonitoringModal: false,
            showChangeCategoryMenu: false,
            selectedList: [],
            selectedCategory: 0,
            downloadlXLSXLoading: false,
            showCompanyChangesModal: false,
            comapnyChangesName: '',
            comapnyChangesOGRN: null,
            companyChangesData: null,
            companyChangesPagination: null,
            companyChangesLoading: false,
            monitoringCompanies: [],
            pagination: {},
            countUnseen: null,
            countTotal: null,
            loading: false,
            order_by: 'changed_at',
            order_type: 'desc',
            searchQuery: '',
            selectedGroup: null
        }
    },
    methods: {
        changeTypeTitle(change_type_title) {
            switch(change_type_title) {
                case 'added': return 'Регистрация ИП'
                case 'updated': return 'Изменение информации о собственности'
                case 'deleted': return 'Ликвидация ИП'
                default: return change_type_title
            }
        },
        sortBy(order_by) {
            if(this.order_by == order_by) {
                if(this.order_type == 'asc') {
                    this.order_type = 'desc'
                } else if(this.order_type == 'desc') {
                    this.order_type = 'asc'
                }
            } else {
                console.log('else else')
                this.order_by = order_by
                this.order_type = 'desc'
            }
            this.getCompanies()
        },
        format_time(time) {
            time += "";
            return time[6] + time[7] + "." + time[4] + time[5] + "." + time[0] + time[1] + time[2] + time[3];
        },
        downloadXLSX(company_id){
            this.downloadlXLSXLoading = true
            this.$store.dispatch('monitoring/downloadXLSX', company_id).finally(() => { this.downloadlXLSXLoading = false })
        },
        getCompanies(offset = 0, limit = 50){
            this.loading = true


            const { order_by, order_type, searchQuery } = this
            const sq = searchQuery ? `&q=${searchQuery}` : ''

            axios({
                method: "get",
                url: `${process.env.API_PRO}monitor/rstperson?demo=true&limit=${limit}&offset=${offset}${sq}&order_by=${order_by}&order_type=${order_type}`,
                headers: {
                    Authorization: `Bearer ${window.apiSession}`
                }
            }).then(e => {
                if(e.data.data) {
                    this.monitoringCompanies = e.data.data
                    this.countUnseen = e.data.data.map(e => parseInt(e.count_unseen)).reduce((a,b) => a + b, 0)
                    this.countTotal = e.data.data.map(e => parseInt(e.count_total)).reduce((a,b) => a + b, 0)
                }
                if(e.data.pagination){
                    this.pagination = e.data.pagination
                }
            }).finally(() => {
                this.loading = false
            })
        },
        showCompanyChanges(offset = 0, limit = 50, company_id, company_name){
            this.companyChangesData = null
            this.comapnyChangesName = company_name
            this.comapnyChangesOGRN = company_id
            this.selectedList = []
            this.getCompanyChanges(offset, limit, company_id)
        },
        getCompanyChanges(offset = 0, limit = 50, company_id = this.comapnyChangesOGRN){
            this.companyChangesLoading = true

            return axios({
                method: 'get',
                url: `${process.env.API_PRO}monitor/rstperson/${company_id}?demo=true&limit=${limit}&offset=${offset}`,
                headers: {
                    Authorization: `Bearer ${window.apiSession}`
                },
            }).then(e => {
                if(e && e.data && e.data.data) {
                    this.companyChangesData = e.data.data
                    this.companyChangesPagination = e.data.pagination
                    this.showCompanyChangesModal = true
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.companyChangesLoading = false
            })
        },
        closeModalHandler() {
            this.showCompanyChangesModal = false 
            this.comapnyChangesName = '' 
            this.comapnyChangesOGRN = null
        }
    },
    mounted(){
        
            this.getCompanies()
        
    },
    computed: {
        auth(){
            return window.auth
        },
        userGroups(){
            return this.$store.state.user?.groups?.filter(e => e.rules.monitoring_fl)
        }
    },
    watch: {
        groupSelect() {
            this.getCompanies()
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables.sass'

$sidebar-width: 230px
$select-width: 200px

.monitoring
    margin-top: $header-height
    width: 100%
    background-color: white
    min-height: calc(100% - #{$header-height})
    z-index: 2
    padding: 50px 0
    font-family: Gotham Pro, sans-serif
    .fas, .fab, .far
        display: inline-block
        width: 20px
        text-align: center
    select
        width: $select-width
        height: 30px
        border-radius: 3px
        outline: 0
        border: 1px solid $link-blue-color
    &__header
        display: flex
        flex-wrap: wrap
        .card-link
            font-size: 22px
            margin: 5px 0
            justify-self: center
            display: block
            margin: 0 auto
        h2
            width: 100%
            margin-bottom: 15px
            font-size: 44px
            font-weight: 800
            @media screen and (max-width: $desktop-resolution)
                font-size: 32px
                text-align: center
    &__content
        display: inline-block
        margin-top: 20px
        margin-bottom: 50px
        vertical-align: top
        font-size: 14px
        width: 100%
        &-sort
            font-weight: 400
            font-size: 13px
            margin: 5px 0
            &-item
                @extend .blue-red-hover-text
                margin-right: 10px
                i.fas
                    margin-right: -3px
                    vertical-align: middle
        &-search-block
            position: relative
            .lnr
                position: absolute
                top: 12px
                font-size: 22px
                cursor: pointer
            .lnr.lnr-magnifier
                right: 46px
                transform: scale(0.9)
            .lnr.lnr-cross
                right: 16px
        &-search
            margin-bottom: 10px
            background: rgba(173, 203, 252, 0.46)
            width: 100%
            display: inline-block
            height: 46px
            line-height: 46px
            border-radius: 6px
            border: 0
            padding: 0 20px
    &__table
        @extends .simple-table
        width: 100%
        font-weight: 400
        font-size: 13px
        &-item
            &-name
                font-weight: 500
                text-decoration: none
                width: 400px
                font-size: 14px
                a
                    border: 0
            &-date
            &-changes
                &-new
                &-all
                    color: #9D9D9D
                    font-weight: 300
                &-show
                    text-decoration: none
                    color: rgba(30, 139, 195,1.0)
                    cursor: pointer
                    border: 0
                    &:hover
                        color: rgba(255,50,50,1.0)
        .fa.fa-check-square, .fa.fa-square-o, .fa.fa-minus-square
            font-family: FontAwesome
            color: #639DFF
            font-size: 20px
            font-weight: normal
            cursor: pointer
            width: 22px
            height: 22px
            display: inline-block
            &::hover
                color: #4285F4
        .fa.fa-check-square,
        .fa.fa-minus-square
            font-size: 18px
        td
            padding: 10px 15px
            vertical-align: top
            &:first-child
                padding-left: 0
            &:last-child
                padding-right: 0
        &-header
            th
                text-align: left
                padding: 10px 15px
                vertical-align: top
                white-space: nowrap
                font-weight: 500
                height: 56px
                &:first-child
                    padding-left: 0
                &:last-child
                    padding-right: 0
            &-changes
                min-width: 160px
            &-category
                position: relative
                min-width: 120px
                text-align: center !important
                ul
                    text-align: left
                    position: absolute
                    top: 20px
                    left: 10px
                    background-color: #fff
                    padding: 10px
                    border: 1px solid lightgray
                    border-radius: 6px
                    li:not(:first-child)
                        margin-top: 8px
            .lnr.lnr-chevron-down
                font-weight: bold
                font-size: 12px
                vertical-align: middle

@media screen and (max-width: $tablet-resolution)
    .monitoring__table
        thead
        tbody
        tr
            display: block
            padding: 10px 0
            &:first-child
                padding: 0
            th
                display: none
            td
                display: block
                padding: 0
                &:nth-child(1),
                &:nth-child(3),
                .monitoring__table-item-changes-new,
                .monitoring__table-item-changes-all
                    display: none
                .monitoring__table-item-changes-show
                    display: inline-block
                    &:after
                        content: " изменения"
</style>